import clsx from 'clsx';
import './Icon.scss';

interface IconProps {
  className?: string;
  children?: React.ReactNode;
}

const Icon: React.FC<IconProps> = ({ className, children }) => {
  return (
    <div className={clsx('ui-icon', className)}>
      <div className="ui-icon__box">
        <svg
          className='ui-icon__circle'
          viewBox="0 0 37 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="18.5" cy="18.2403" r="17.6764" className='svg-stroke' strokeWidth="0.8" />
          <circle cx="18.5" cy="18.2402" r="16.201" className='svg-stroke' strokeWidth="0.8" />
        </svg>

        <div className="ui-icon__wrapper">
          <div className="ui-icon__content">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Icon;
